module.exports = __webpack_public_path__ + "static/3-fccbb825d3febae2c4588878c748353a.png";